import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogArticlePage from "../pages/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/acbuy-spreadsheet-guide",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-review",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-vs-competitors",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-beginners",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-pricing",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-categories",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-safety",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-tips",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-mistakes",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-updates",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-sourcing",
    element: <BlogArticlePage />,
  },
  {
    path: "/acbuy-spreadsheet-faqs",
    element: <BlogArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;